import React from "react";
import { Link } from "react-router";

const Footer = () => {
  return (
    <div className="lg:relative bg-gray-950 w-full flex flex-col lg:flex-row md:justify-end text-secundario gap-8 md:gap-4 lg:gap-5 p-6 md:p-10 lg:p-12 xl:p-20">
      <div
        className="lg:absolute lg:left-12 xl:left-20 lg:top-1/2 lg:-translate-y-1/2 w-full md:w-1/2 lg:w-1/4
       flex md:self-center lg:flex-col gap-5 justify-center items-center"
      >
        {/* <p className="text-2xl w-1/2">
          Minimizing Delaysand Maximizing Returns: Our Mission
        </p> */}
        <Link to={"/"}>
          <img
            src="https://innovativeld.com/assets/Logo-InnovativeLD.png"
            alt="Innovative Land Developers"
            className="w-52 sm:w-52 md:w-full max-w-full"
          />
        </Link>
      </div>
      <div className="w-full md:w-2/3 lg:w-1/5 flex flex-col gap-4">
        <p className="relative w-full sm:w-2/3 md:w-full lg:w-full 2xl:w-2/3 font-bold text-base  h-10 font-primaria">
          Explore{" "}
          <span className="absolute left-0 bottom-0 bg-secundario w-full h-[2px] my-2"></span>
        </p>
        <Link
          className="w-full sm:w-2/3 md:w-full lg:w-2/3 hover:opacity-90 transition text-base "
          to="services"
        >
          Services
        </Link>
        <Link
          className="w-full sm:w-2/3 md:w-full lg:w-2/3 hover:opacity-90 transition text-base "
          to="projects"
        >
          Projects
        </Link>
        <Link
          className="w-full sm:w-2/3 md:w-full lg:w-2/3 hover:opacity-90 transition text-base "
          to="about"
        >
          About
        </Link>
        <Link
          className="w-full sm:w-2/3 md:w-full lg:w-2/3 hover:opacity-90 transition text-base "
          to="faqs"
        >
          FAQs
        </Link>

        <Link
          className="w-full sm:w-2/3 md:w-full lg:w-2/3 hover:opacity-90 transition text-base "
          to="consultation"
        >
          Contact
        </Link>
      </div>
      <div className="w-full md:w-2/3 lg:w-1/5 flex flex-col gap-4">
        <p className="font-primaria relative w-full sm:w-2/3 md:w-full 2xl:w-2/3 font-bold text-base  h-10">
          Let's start{" "}
          <span className="absolute left-0 bottom-0 bg-secundario w-full h-[2px] my-2"></span>
        </p>
        <Link
          className="w-full sm:w-2/3 md:w-full  hover:opacity-90 transition text-base "
          to={"consultation"}
        >
          Book a consultation
        </Link>
        <Link
          className="w-full sm:w-2/3 md:w-full  hover:opacity-90 transition text-base "
          to={"entitlement"}
        >
          Entitlement Risk Scan
        </Link>
      </div>
      <div className="w-full md:w-2/3 lg:w-1/5  flex flex-col gap-2 ">
        <p className="font-primaria relative w-full sm:w-2/3 md:w-full 2xl:w-2/3 font-bold text-base  h-10">
          Contact Us{" "}
          <span className="absolute left-0 bottom-0 bg-secundario w-full h-[2px] my-2"></span>
        </p>
        {/* <span className="font-bold font-primaria w-full sm:w-2/3 md:w-full text-sm ">
          Office:
        </span>
        <a
          href="tel:+15712105176"
          className="w-full sm:w-2/3 md:w-full  hover:opacity-90 transition text-base "
        >
          +1 (571) 210-5176
        </a> */}
        <span className="font-bold font-primaria w-full sm:w-2/3 md:w-full text-sm ">
          Mobile:
        </span>
        <a
          href="tel:+17035179492"
          className="w-full sm:w-2/3 md:w-full  hover:opacity-90 transition text-base "
        >
          +1 (703) 517-9492
        </a>
        <a
          href="tel:+12024807489"
          className="w-full sm:w-2/3 md:w-full  hover:opacity-90 transition text-base "
        >
          +1 (202) 480-7489
        </a>
        <a
          href="tel:+17038255012"
          className="w-full sm:w-2/3 md:w-full  hover:opacity-90 transition text-base "
        >
          +1 (703) 825-5012
        </a>
        <span className="font-bold font-primaria w-full sm:w-2/3 md:w-full text-sm ">
          Email:
        </span>
        <a
          className="w-full sm:w-2/3 md:w-full hover:opacity-90 transition text-base "
          href="mailto:info@innovativeld.com"
        >
          info@innovativeLD.com
        </a>
        <p className="font-primaria relative w-full sm:w-2/3 md:w-full lg:w-full 2xl:w-2/3 font-bold text-base h-10 mt-3">
          Our address{" "}
          <span className="absolute left-0 bottom-0 bg-secundario w-full h-[2px] my-2"></span>
        </p>
        <a
          className="w-full sm:w-2/3 md:w-1/2 lg:w-full hover:opacity-90 transition text-base"
          href="https://maps.app.goo.gl/PvJ4DUWsFmiA3JXg8"
          target="_blank"
          rel="noopener noreferrer"
        >
          3933 Avion Park Ct, Ste B102A, Chantilly, VA 20151
        </a>
        <p className="text-base hover:opacity-90 transition">Monday through Friday, 8:00 a.m. to 5:00 p.m. ET</p>
        <div className="w-full flex flex-row flex-wrap items-center  lg:justify-center 2xl:justify-start gap-4 sm:gap-5 mt-4">
          <a
            href="https://www.instagram.com/innovativeland?igsh=bGpzMXJ4MjdlaWxs"
            target="_blank"
            rel="noopener noreferrer"
            className="hover:opacity-90 transition w-8 md:w-8"
          >
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
              <path
                fill="#fbf3e6"
                d="M224.3 141a115 115 0 1 0 -.6 230 115 115 0 1 0 .6-230zm-.6 40.4a74.6 74.6 0 1 1 .6 149.2 74.6 74.6 0 1 1 -.6-149.2zm93.4-45.1a26.8 26.8 0 1 1 53.6 0 26.8 26.8 0 1 1 -53.6 0zm129.7 27.2c-1.7-35.9-9.9-67.7-36.2-93.9-26.2-26.2-58-34.4-93.9-36.2-37-2.1-147.9-2.1-184.9 0-35.8 1.7-67.6 9.9-93.9 36.1s-34.4 58-36.2 93.9c-2.1 37-2.1 147.9 0 184.9 1.7 35.9 9.9 67.7 36.2 93.9s58 34.4 93.9 36.2c37 2.1 147.9 2.1 184.9 0 35.9-1.7 67.7-9.9 93.9-36.2 26.2-26.2 34.4-58 36.2-93.9 2.1-37 2.1-147.8 0-184.8zM399 388c-7.8 19.6-22.9 34.7-42.6 42.6-29.5 11.7-99.5 9-132.1 9s-102.7 2.6-132.1-9c-19.6-7.8-34.7-22.9-42.6-42.6-11.7-29.5-9-99.5-9-132.1s-2.6-102.7 9-132.1c7.8-19.6 22.9-34.7 42.6-42.6 29.5-11.7 99.5-9 132.1-9s102.7-2.6 132.1 9c19.6 7.8 34.7 22.9 42.6 42.6 11.7 29.5 9 99.5 9 132.1s2.7 102.7-9 132.1z"
              />
            </svg>
          </a>
          <a
            href="https://www.linkedin.com/company/innovative-land-developers/"
            target="_blank"
            rel="noopener noreferrer"
            className="hover:opacity-90 transition w-8 md:w-9"
          >
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
                <path
                  fill="#fbf3e6"
                  d="M416 32L31.9 32C14.3 32 0 46.5 0 64.3L0 447.7C0 465.5 14.3 480 31.9 480L416 480c17.6 0 32-14.5 32-32.3l0-383.4C448 46.5 433.6 32 416 32zM135.4 416l-66.4 0 0-213.8 66.5 0 0 213.8-.1 0zM102.2 96a38.5 38.5 0 1 1 0 77 38.5 38.5 0 1 1 0-77zM384.3 416l-66.4 0 0-104c0-24.8-.5-56.7-34.5-56.7-34.6 0-39.9 27-39.9 54.9l0 105.8-66.4 0 0-213.8 63.7 0 0 29.2 .9 0c8.9-16.8 30.6-34.5 62.9-34.5 67.2 0 79.7 44.3 79.7 101.9l0 117.2z"
                />
              </svg>
            </svg>
          </a>
        </div>
      </div>
    </div>
  );
};

export default Footer;
